import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'

import {
  Container,
  Label
} from '../../../styles/global'
import {
  ForgotPasswordContainer,
  ContainerEmail,
  LabelForgotPassword,
  InputEmail,
  ButtonSend,
  SpanPasswordSent
} from './styles'
import { ButtonLeft, Header, Navigation } from '../../Professionals/DailyView/styles'
import { sendForgotPasswordEmail } from '../../../services/professionals'

const ForgotPasswordView = () => {
  const history = useHistory()
  const query = new URLSearchParams(useLocation().search)
  const email = query.get('email')
  const source = query.get('source')
  const deviceId = query.get('deviceId')
  const { professionalId } = useParams()
  const [passwordSent, setPasswordSent] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSendForgotPasswordEmail = async () => {
    setLoading(true)
    await sendForgotPasswordEmail(professionalId)
    setPasswordSent(true)
    setLoading(false)
  }

  const handleBackButton = async () => {
    let loginPathname = '/login'
    if (deviceId) loginPathname += `?deviceId=${deviceId}`
    if (source) {
      loginPathname += (source && deviceId) ? `&source=${source}` : `?source=${source}`
    }

    history.push(loginPathname)
  }

  return (
    <Container>
      <Header>
        <Navigation onClick={handleBackButton}>
          <ButtonLeft />
          <LabelForgotPassword> Voltar</LabelForgotPassword>
        </Navigation>
      </Header>
      <ForgotPasswordContainer>
        <div>
          <h2>Esqueceu a senha ?</h2>
        </div>
        <span>
          <LabelForgotPassword className='label-container'>
            Clique em enviar abaixo para enviar um e-mail e redefinir sua senha.
          </LabelForgotPassword>
        </span>
        <ContainerEmail>
          <Label>E-mail</Label>
          <InputEmail value={email} disabled={true} />
          { passwordSent && (
            <SpanPasswordSent>Email enviado com sucesso</SpanPasswordSent>
          )}
        </ContainerEmail>
        <ButtonSend onClick={handleSendForgotPasswordEmail} disabled={loading}>
          Enviar
        </ButtonSend>
      </ForgotPasswordContainer>
    </Container>
  )
}

export default ForgotPasswordView
